import React from 'react';

import { Portal } from '@bringg-frontend/bringg-web-infra';

import StoreAppSettingsContainer from './store-app/store-app-container/store-app-container';

export const StoreAppSettingsPortal = () => {
	return <Portal element={<StoreAppSettingsContainer />} nodeId="store-app-settings-portal" />;
};
